import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async fetchDprHeader({ commit }, mainId) {
    Vue.$log.debug('loading dpr header for', mainId);
    let dprMainId = mainId || '00000000-0000-0000-0000-000000000000';
    return Vue.axios.get(Vue.$url("dpr-header/" + dprMainId))
      .then((rsp) => {
        commit("SET_DPR_HEADER", rsp.data)
        return rsp.data;
      });
  },

  async fetchDprHeaderNo({ commit }, pvId) {
    Vue.$log.debug('loading next header number of pv', pvId);
    return Vue.axios.get(Vue.$url("dpr-header/number?pvId=" + pvId))
      .then((rsp) => {
        commit("SET_DPR_HEADER_NO", rsp.data)
        return rsp.data;
      });
  },

  async fetchCoords({ commit }) {
    Vue.$log.debug('loading coordinates');
    return Vue.axios.get(Vue.$url("dpr-header/coords"))
      .then((rsp) => {
        commit("SET_COORDS", rsp.data)
        return rsp.data;
      });
  },

  async finalizeCloseDpr({ commit }, payload) {
    let endpoint = 'dpr-header/' + payload.dprMainId + '/file/' + payload.dprFileId + '/finalize-close?sendToDL=' + payload.sendToDL;
    return Vue.axios
      .post(Vue.$url(endpoint), payload)
      .then(() => commit('mShowInfoMessage', i18n.t('dpr.senseddl'), { root: true }));
  },


}